import React from 'react';
import * as yup from 'yup';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { api } from '@api';
import { HookFormTextInput } from '@components/ReactHookFormFields/HookFormTextInput';
import { useIncidentCreation } from '@hooks/incidents';
import { useCustomTranslations } from '@hooks/useCustomTranslations';
import {
  IncidentClassification,
  IncidentSubClassification,
} from '@models/Incident';
import { isValidIBAN } from '@utils/ibanUtils';

import { IncidentFormWrapper } from '../IncidentFormWrapper';

type FormValues = {
  description: string;
  files?: File[];
};

export const PaymentsSecurityDepositReturnMovingOutForm = ({
  customTranslations,
}: ParsedEntry<IWidget>) => {
  const { t, tContentful } = useCustomTranslations(customTranslations);

  const { create } = useIncidentCreation({
    postIncident: api.incidents.postGenericIncident,
    classifications: {
      classification: IncidentClassification.RENTALPAYMENT_STATUS,
      subClassification: IncidentSubClassification.RENT_GUARANTEE_RETURN,
    },
    messageTitlePrefix: t('messageTitlePrefix'),
  });

  return (
    <IncidentFormWrapper<FormValues>
      incidentKind="PaymentsSecurityDepositReturnMovingOut"
      defaultValues={{
        description: '',
        files: [],
      }}
      validationSchema={yup.object().shape({
        files: yup.array().files(tContentful),
        description: yup
          .string()
          .required()
          .test({
            test: (value = '') => isValidIBAN(value),
            message: t('invalidIBAN'),
          }),
      })}
      onSubmit={create}
    >
      <HookFormTextInput
        name="description"
        type="text"
        label={{ value: t('accountNumberLabel'), type: 'static' }}
        message={t('accountNumberHelper')}
        maxLength={150}
      />
    </IncidentFormWrapper>
  );
};
